import React, { PropsWithChildren } from "react"

import { styled } from "@mui/material"

export const MainLayout = ({ children }: PropsWithChildren) => {
  return (<>
    <Container className="sfl-wrapper">
      {children}
    </Container>
    <div id="sfl-footer"/>
  </>)
}

const Container = styled("main")(({ theme }) => ({
  minHeight: "100vh",
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1fr minmax(0, 544px) 1fr",
  gridTemplateRows: "auto auto 1fr",
  alignItems: "start",
  padding: "80px 24px 0 24px",

  fontFeatureSettings: "'liga' off, 'clig' off",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "normal",

  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "16px",
  }
}))

